import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

const initialiseDatadog = context => {
    const datadogConfig = context?.datadog;
    if (
        !datadogConfig?.clientToken ||
        !datadogConfig.applicationId ||
        datadogConfig[(context?.env)]?.disabled
    ) {
        return;
    }

    datadogRum.init({
        applicationId: datadogConfig.applicationId,
        clientToken: datadogConfig.clientToken,
        site: 'datadoghq.eu',
        service: 'promo-webtool',
        env: context.env,
        version: context.versionTag,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackUserInteractions: true,
        trackInteractions: true,
        trackFrustrations: true,
        trackLongTasks: true,
        trackResources: true,
        enableExperimentalFeatures: ['clickmap'],
        allowedTracingUrls: [context.clientUrl],
    });
    datadogLogs.init({
        applicationId: datadogConfig.applicationId,
        clientToken: datadogConfig.clientToken,
        site: 'datadoghq.eu',
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
    });
};

export default initialiseDatadog;
